import { render, staticRenderFns } from "./taxonomy.vue?vue&type=template&id=56c87fdb&"
import script from "./taxonomy.vue?vue&type=script&lang=js&"
export * from "./taxonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports